import { useEffect, useState } from "react";

export default function usePreloadImages({ imageUrls = [] }) {
  const [isLoading, setIsLoading] = useState(imageUrls.length > 0);

  useEffect(() => {
    let imageLoadCount = 0;
    setIsLoading(imageUrls.length > 0);

    const handleImageLoad = () => {
      imageLoadCount += 1;

      if (imageLoadCount === imageUrls.length) {
        setIsLoading(false);
      }
    };

    const removeEventListeners = imageUrls
      .filter((imageUrl) => !imageUrl.includes("[") && !imageUrl.includes("]"))
      .map((imageUrl) => {
        const tempImage = new Image();
        tempImage.addEventListener("load", handleImageLoad, true);
        tempImage.addEventListener("error", handleImageLoad, true);
        tempImage.src = imageUrl;

        return () => {
          tempImage.removeEventListener("load", handleImageLoad, true);
          tempImage.removeEventListener("error", handleImageLoad, true);
        };
      });

    return () => {
      removeEventListeners.map((removeEventListeners) =>
        removeEventListeners.call(null)
      );
    };
  }, [imageUrls.join("|")]);

  return {
    isLoading,
  };
}
